import ValidationBorder from "./ValidationBorder.mjs";
export * from "./ValidationBorder.mjs";
var lib_default = ValidationBorder;
export {
  lib_default as default
};
